<template>
  <div class="project-system">
    <div class="project-system-box">
      <Nav />
      <div class="project-system-middle">
        <div class="project-system-title">感谢您对房屋安置工作的配合与支持</div>
        <div class="project-system-content">
          <div class="project-system-one">
            <div class="one-left">
              <img src="../../assets/img/user.png" />
            </div>
            <div class="one-right">
              总户数
              <span class="text">{{content.householdCount}}</span> 户
            </div>
          </div>
          <div class="project-system-one">
            <div class="one-left">
              <img src="../../assets/img/sign.png" />
            </div>
            <div class="one-right">
              已签约户数
              <span class="text">{{content.signHouseholdCount}}</span> 户
            </div>
          </div>
          <div class="project-system-one">
            <div class="one-left">
              <img src="../../assets/img/date.png" />
            </div>
            <div class="one-right">
              距签约期限还有
              <span class="text">{{content.signDateDistanceDays}}</span> 天
            </div>
          </div>
          <div class="project-system-one">
            <div class="one-left">签约进度</div>
            <div class="one-right">
              <el-progress
                :percentage="content.signPercent"
                :stroke-width="18"
                color="rgba(2, 91, 145, 1)"
                style="color:red;display: flex;"
              ></el-progress>
            </div>
          </div>
        </div>
        <div class="project-system-overview">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="项目概况" name="first">
              <div class="system-overview-content" v-html="content.overview" v-if="flag"></div>
              <div class="system-overview-none" v-else>暂无数据信息</div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryPublicityProjectDetail } from '@/api/publicinquiry.api.js';
import { setSession, getSession } from '@/untils';
import Nav from '@/components/nav.vue';
export default {
  components: {
    Nav
  },
  computed: {
    flag() {
      if (this.content.overview) {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      activeName: 'first',
      projectId: '',
      content: {}
    };
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'projectlist' });
    },
    handleClick() {},
    queryPublicityProjectDetail() {
      queryPublicityProjectDetail(this.projectId).then(res => {
        this.content = res.body;
      });
    }
  },
  created() {
    this.projectId = getSession('projectId');
    this.queryPublicityProjectDetail();
  }
};
</script>
<style>
.project-system {
  height: 100%;
}
.project-system-box {
  height: 100%;
  background: #ffffff;
}
.project-system-header {
  height: 40px;
  border-bottom: 1px solid rgb(2, 91, 145);
}
.project-system-middle {
  overflow: auto;
  height: calc(100% - 53px);
}
.project-system-left {
  float: left;
  padding: 5px 0;
  text-indent: 15px;
  color: #025b91;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
}
.project-system-right {
  float: right;
  display: flex;
}
.system-left {
  padding: 5px 150px;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  color: #1e1e1e;
}
.system-right {
  height: 30px;
  background: inherit;
  background-color: rgba(2, 91, 145, 1);
  border: none;
  border-top: 0px;
  border-radius: 10px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
}
.project-system-title {
  text-align: center;
  color: #333333;
  font-size: 28px;
  margin-top: 28px;
}
.project-system-content {
  padding-left: 150px;
  padding-top: 60px;
}
.project-system-one {
  display: flex;
  padding: 10px 0px;
}
.one-left img {
  width: 20px;
}
.one-left {
  padding-right: 25px;
}
.one-right {
  width: 30%;
}
.text {
  color: red;
}
.el-progress__text {
  color: red;
}
.project-system-overview {
  padding: 0 30px;
  margin-top: 28px;
}
.el-tabs__item.is-active {
  color: #025b91;
}
.el-tabs__active-bar {
  background: #025b91;
}
.system-overview-none {
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #999999;
}
.system-overview-content {
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/page/project-system/index.vue